// When to re-check a licence, and how long it lasts without a connection (F13). Pure.
export const REVALIDATE_MS = 7 * 24 * 3600 * 1000;
export const OFFLINE_GRACE_MS = 30 * 24 * 3600 * 1000;

export function needsRevalidation(validatedAt: number, now: number): boolean {
  return now - validatedAt > REVALIDATE_MS;
}

/** A licence keeps working offline for 30 days after its last successful check. */
export function withinGrace(validatedAt: number, now: number): boolean {
  return now - validatedAt <= OFFLINE_GRACE_MS;
}
